import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// helpers

import { useCarouselContext } from '~/shared/components/CarouselContext';
import { isMobile as isMobileDevice } from '~/shared/utils/helpers';
import { desktop, Carousel, mobile } from '~/techstyle-shared/react-components';

import MarketingCard from '../MarketingCard';

const wrapperStyle = css`
  margin: auto;

  data-carousel-cell {
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .flickity-page-dots {
    bottom: 10px;
  }
  .flickity-viewport {
    min-height: 100%;
    margin-top: -10px;
    padding: 10px 0px 12px 0px;
    box-sizing: content-box;

    ${mobile`
        min-height: 75vw;
    `}
  }
`;

const cellStyle = css`
  margin-right: 6px;
  width: 319px;

  ${mobile`
    margin-left: 24px;
  `}

  ${desktop`
    margin-right: 30px;
  `}
`;

const mobileCardLayoutCellStyle = css`
  margin-right: 6px;
  width: 319px;
  ${desktop`
    margin-right: 30px;
  `}
`;

const verticalCellStyle = css`
  margin-right: 6px;
  max-width: 60%;
  ${desktop`
    margin-right: 30px;
  `}
`;

const CarouselWrapper = styled(Carousel)`
  height: 100%;
`;
const CarouselContainer = styled.div`
  width: 100%;
`;

const MarketingCardsCarousel = ({
  assets,
  cardVariant,
  mobileCardLayout,
  refs,
}) => {
  const isMobile =
    typeof window !== 'undefined' && isMobileDevice(window?.navigator);

  const { setFlickity } = useCarouselContext();
  const flickityRef = useCallback(
    (flickityNode) => {
      if (flickityNode) {
        setFlickity(flickityNode);
      }
    },
    [setFlickity]
  );

  let carouselSettings = {};
  carouselSettings = {
    selectedAttraction: isMobile ? 0.025 : 0.01,
    friction: isMobile ? 0.28 : 0.21,
    draggable: isMobile,
    freeScroll: isMobile,
    flickityRef,
    cellStyle:
      mobileCardLayoutCellStyle === 'vertical' ? verticalCellStyle : cellStyle,
    wrapperStyle,
    adaptiveHeight: false,
    cellAlign: isMobile ? 'left' : 'center',
  };
  return (
    <CarouselContainer>
      <CarouselWrapper variant="marketingCards" {...carouselSettings}>
        {assets.map((asset, index) => (
          <MarketingCard
            asset={asset}
            key={index}
            cardVariant={cardVariant}
            mobileCardLayout={mobileCardLayout}
            refs={refs}
          />
        ))}
      </CarouselWrapper>
    </CarouselContainer>
  );
};

export default MarketingCardsCarousel;

MarketingCardsCarousel.propTypes = {
  assetContainerType: PropTypes.string,
  assets: PropTypes.array,
  cardVariant: PropTypes.string,
  mobileCardLayout: PropTypes.string,
  refs: PropTypes.object,
};
